var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1643_9379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8337 14V12.6667C11.8337 11.9594 11.5527 11.2811 11.0526 10.781C10.5525 10.281 9.87424 10 9.16699 10H3.83366C3.12641 10 2.44814 10.281 1.94804 10.781C1.44794 11.2811 1.16699 11.9594 1.16699 12.6667V14M15.8337 14V12.6667C15.8332 12.0758 15.6366 11.5018 15.2746 11.0349C14.9126 10.5679 14.4057 10.2344 13.8337 10.0867M11.167 2.08667C11.7406 2.23353 12.249 2.56713 12.6121 3.03487C12.9752 3.50261 13.1722 4.07789 13.1722 4.67C13.1722 5.26211 12.9752 5.83739 12.6121 6.30513C12.249 6.77287 11.7406 7.10647 11.167 7.25333M9.16699 4.66667C9.16699 6.13943 7.97308 7.33333 6.50033 7.33333C5.02757 7.33333 3.83366 6.13943 3.83366 4.66667C3.83366 3.19391 5.02757 2 6.50033 2C7.97308 2 9.16699 3.19391 9.16699 4.66667Z",
    stroke: "#5E639B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1643_9379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.8786bad9112d3ad96bd7316fe48c4760.svg";
export { ForwardRef as ReactComponent };